/*
 * feed.js · CMS de yanipaper-3d — AUTO-GENERADO desde Strapi (yanipaper-cms/scripts/export-feed.mjs).
 * NO EDITAR A MANO: se sobrescribe en cada publicación. El esquema y las funciones son estables;
 * solo cambian SECCIONES y POSTS. El frontend no se toca. Cada post enlaza a /blog/<slug>.html.
 * Generado leyendo http://127.0.0.1:1337 (posts publicados).
 */

/** Secciones editoriales (desde Strapi). */
export const SECCIONES = [
  {
    "slug": "desaparicion-forzada",
    "name": "Desaparición forzada",
    "descripcion": "Personas desaparecidas y búsqueda en Jalisco y México.",
    "orden": 1,
    "sensible": true
  },
  {
    "slug": "violencia-de-genero",
    "name": "Violencia de género",
    "descripcion": "Feminicidios y violencias machistas: el dato como denuncia y memoria.",
    "orden": 2,
    "sensible": true
  },
  {
    "slug": "inseguridad",
    "name": "Inseguridad",
    "descripcion": "Violencia, delito y seguridad pública desde una mirada crítica de los datos.",
    "orden": 3,
    "sensible": false
  },
  {
    "slug": "crisis-de-vivienda",
    "name": "Crisis de vivienda",
    "descripcion": "Gentrificación, despojo y derecho a la ciudad.",
    "orden": 4,
    "sensible": false
  },
  {
    "slug": "crisis-hidrica",
    "name": "Crisis hídrica",
    "descripcion": "Agua, territorio y conflicto socioambiental.",
    "orden": 5,
    "sensible": false
  },
  {
    "slug": "corrupcion-y-opacidad",
    "name": "Corrupción y opacidad",
    "descripcion": "Transparencia, rendición de cuentas y opacidad institucional.",
    "orden": 6,
    "sensible": false
  },
  {
    "slug": "sistema-politico",
    "name": "Sistema político",
    "descripcion": "Poder, elecciones e instituciones bajo escrutinio.",
    "orden": 7,
    "sensible": false
  }
];

/** Posts publicados (desde Strapi). `destacado`=importancia; `fecha`=recencia; `cover`=portada o null. */
export const POSTS = [
  {
    "slug": "demo-scraper-transparencia",
    "title": "ejemplo — Cómo armé el scraper del portal de transparencia",
    "seccion": "corrupcion-y-opacidad",
    "tipo": "blog",
    "fecha": "2026-06-12",
    "excerpt": "Texto de demostración: el resumen del post tal como lo escribiría Héctor en el CMS.",
    "destacado": true,
    "cover": null,
    "enlace": "/blog/demo-scraper-transparencia.html",
    "tags": []
  },
  {
    "slug": "demo-pieza-cartografia",
    "title": "ejemplo — Cartografía interactiva de prueba",
    "seccion": "crisis-de-vivienda",
    "tipo": "pieza-especial",
    "fecha": "2026-06-10",
    "excerpt": "Texto de demostración. Resumen de una pieza especial de ejemplo.",
    "destacado": true,
    "cover": null,
    "enlace": "/blog/demo-pieza-cartografia.html",
    "tags": []
  },
  {
    "slug": "demo-datificacion-critica",
    "title": "ejemplo — Apuntes sobre datificación crítica",
    "seccion": "desaparicion-forzada",
    "tipo": "blog",
    "fecha": "2026-06-09",
    "excerpt": "Texto de demostración. Post en sección sensible.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-datificacion-critica.html",
    "tags": []
  },
  {
    "slug": "demo-openrefine",
    "title": "ejemplo — Tutorial: limpiar datos con OpenRefine",
    "seccion": "inseguridad",
    "tipo": "blog",
    "fecha": "2026-06-06",
    "excerpt": "Texto de demostración. Otro post de blog de ejemplo.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-openrefine.html",
    "tags": []
  },
  {
    "slug": "demo-pieza-dashboard",
    "title": "ejemplo — Dashboard de prueba",
    "seccion": "sistema-politico",
    "tipo": "pieza-especial",
    "fecha": "2026-06-04",
    "excerpt": "Texto de demostración. Pieza especial de ejemplo con enlace externo.",
    "destacado": false,
    "cover": null,
    "enlace": "https://example.org/demo",
    "tags": []
  },
  {
    "slug": "demo-notas-campo",
    "title": "ejemplo — Notas de campo desde Jalisco",
    "seccion": "violencia-de-genero",
    "tipo": "blog",
    "fecha": "2026-06-02",
    "excerpt": "Texto de demostración. Post en sección sensible.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-notas-campo.html",
    "tags": []
  },
  {
    "slug": "demo-subregistro-desaparicion",
    "title": "ejemplo — El subregistro en los datos de desaparición",
    "seccion": "desaparicion-forzada",
    "tipo": "blog",
    "fecha": "2026-05-30",
    "excerpt": "Texto de demostración. La cifra negra como categoría analítica.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-subregistro-desaparicion.html",
    "tags": []
  },
  {
    "slug": "demo-mapa-feminicidios",
    "title": "ejemplo — Mapa de feminicidios: por qué abruma",
    "seccion": "violencia-de-genero",
    "tipo": "pieza-especial",
    "fecha": "2026-05-28",
    "excerpt": "Texto de demostración. Oclusión política: la saturación que honra cada vida.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-mapa-feminicidios.html",
    "tags": []
  },
  {
    "slug": "demo-caja-chica",
    "title": "ejemplo — La caja chica del ayuntamiento, fila por fila",
    "seccion": "corrupcion-y-opacidad",
    "tipo": "blog",
    "fecha": "2026-05-25",
    "excerpt": "Texto de demostración. Cómo un PDF escaneado se vuelve base consultable.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-caja-chica.html",
    "tags": []
  },
  {
    "slug": "demo-gentrificacion-zmg",
    "title": "ejemplo — Índice de gentrificación en la ZMG",
    "seccion": "crisis-de-vivienda",
    "tipo": "pieza-especial",
    "fecha": "2026-05-22",
    "excerpt": "Texto de demostración. Desplazamiento urbano medido AGEB por AGEB.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-gentrificacion-zmg.html",
    "tags": []
  },
  {
    "slug": "demo-estres-hidrico",
    "title": "ejemplo — Pozos secos: el mapa del estrés hídrico",
    "seccion": "crisis-hidrica",
    "tipo": "pieza-especial",
    "fecha": "2026-05-19",
    "excerpt": "Texto de demostración. Agua, territorio y conflicto en una capa de datos.",
    "destacado": true,
    "cover": null,
    "enlace": "/blog/demo-estres-hidrico.html",
    "tags": []
  },
  {
    "slug": "demo-serie-oficial-sospecha",
    "title": "ejemplo — Cómo leer una serie oficial con sospecha",
    "seccion": "inseguridad",
    "tipo": "blog",
    "fecha": "2026-05-16",
    "excerpt": "Texto de demostración. Cambios metodológicos sospechosos en las series.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-serie-oficial-sospecha.html",
    "tags": []
  },
  {
    "slug": "demo-eleccion-judicial",
    "title": "ejemplo — La elección judicial en un dashboard",
    "seccion": "sistema-politico",
    "tipo": "pieza-especial",
    "fecha": "2026-05-13",
    "excerpt": "Texto de demostración. Primera elección judicial de México, dato a dato.",
    "destacado": true,
    "cover": null,
    "enlace": "/blog/demo-eleccion-judicial.html",
    "tags": []
  },
  {
    "slug": "demo-territorios-desaparicion",
    "title": "ejemplo — Territorios de la desaparición",
    "seccion": "desaparicion-forzada",
    "tipo": "pieza-especial",
    "fecha": "2026-05-10",
    "excerpt": "Texto de demostración. Dónde la desaparición configura una crisis humanitaria.",
    "destacado": true,
    "cover": null,
    "enlace": "/blog/demo-territorios-desaparicion.html",
    "tags": []
  },
  {
    "slug": "demo-luciernagas",
    "title": "ejemplo — Luciérnagas en el porvenir",
    "seccion": "violencia-de-genero",
    "tipo": "pieza-especial",
    "fecha": "2026-05-07",
    "excerpt": "Texto de demostración. Memorial sobre buscadoras desaparecidas y asesinadas.",
    "destacado": true,
    "cover": null,
    "enlace": "/blog/demo-luciernagas.html",
    "tags": []
  },
  {
    "slug": "demo-selenium-portales",
    "title": "ejemplo — Selenium para portales que se resisten",
    "seccion": "corrupcion-y-opacidad",
    "tipo": "blog",
    "fecha": "2026-05-04",
    "excerpt": "Texto de demostración. El scraping construye contra-archivos.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-selenium-portales.html",
    "tags": []
  },
  {
    "slug": "demo-parque-rojo",
    "title": "ejemplo — Costos del Parque Rojo, desglosados",
    "seccion": "corrupcion-y-opacidad",
    "tipo": "pieza-especial",
    "fecha": "2026-05-01",
    "excerpt": "Texto de demostración. Costos de remodelación, partida por partida.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-parque-rojo.html",
    "tags": []
  },
  {
    "slug": "demo-cartografia-textil",
    "title": "ejemplo — Cartografía textil como resistencia",
    "seccion": "crisis-de-vivienda",
    "tipo": "pieza-especial",
    "fecha": "2026-04-27",
    "excerpt": "Texto de demostración. Prácticas textiles como acto de memoria colectiva.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-cartografia-textil.html",
    "tags": []
  },
  {
    "slug": "demo-cartografia-procesual",
    "title": "ejemplo — Notas sobre cartografía procesual",
    "seccion": "crisis-hidrica",
    "tipo": "blog",
    "fecha": "2026-04-23",
    "excerpt": "Texto de demostración. Los mapas no representan: performan el territorio.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-cartografia-procesual.html",
    "tags": []
  },
  {
    "slug": "demo-padron-electoral",
    "title": "ejemplo — Anatomía de un padrón electoral",
    "seccion": "sistema-politico",
    "tipo": "blog",
    "fecha": "2026-04-19",
    "excerpt": "Texto de demostración. Qué se puede y qué no se debe inferir de un padrón.",
    "destacado": false,
    "cover": null,
    "enlace": "/blog/demo-padron-electoral.html",
    "tags": []
  },
  {
    "slug": "costos-de-rehabilitacion-parque-rojo",
    "title": "Esto costó la rehabilitación del Parque Rojo",
    "seccion": "corrupcion-y-opacidad",
    "tipo": "blog",
    "fecha": "2026-07-10",
    "excerpt": "",
    "destacado": false,
    "cover": "assets/images/cms-costos-de-rehabilitacion-parque-rojo.png",
    "enlace": "/blog/costos-de-rehabilitacion-parque-rojo.html",
    "tags": []
  },
  {
    "slug": "caja-chica-de-guadalajara",
    "title": "La caja chica de Guadalajara o los gastos innecesarios",
    "seccion": "corrupcion-y-opacidad",
    "tipo": "blog",
    "fecha": "2026-07-10",
    "excerpt": "",
    "destacado": false,
    "cover": "assets/images/cms-caja-chica-de-guadalajara.png",
    "enlace": "/blog/caja-chica-de-guadalajara.html",
    "tags": [
      "corrupcion, guadalajara"
    ]
  }
];

/** Único punto de acceso a los datos. */
export function loadFeed() {
  return { secciones: SECCIONES, posts: POSTS };
}

/**
 * Agrupa el feed en PISOS (uno por sección, orden alfabético). Dentro de cada piso, por RECENCIA
 * (fecha desc). El relleno ficticio a 7 piezas es temporal para previsualizar los 3 niveles.
 */
export function buildPisos(feed = loadFeed()) {
  const { secciones, posts } = feed;
  return [...secciones]
    .sort((a, b) => a.name.localeCompare(b.name, 'es'))
    .map((sec) => {
      const suyos = posts
        .filter((p) => p.seccion === sec.slug)
        .sort((a, b) => (a.fecha < b.fecha ? 1 : a.fecha > b.fecha ? -1 : 0));
      const MIN = 7;
      const rellenados = suyos.length === 0 || suyos.length >= MIN
        ? suyos
        : Array.from({ length: MIN }, (_, i) =>
            i < suyos.length
              ? suyos[i]
              : { ...suyos[i % suyos.length], slug: `${suyos[i % suyos.length].slug}-demo${i}`, _relleno: true }
          );
      return { ...sec, posts: rellenados };
    })
    .filter((piso) => piso.posts.length > 0);
}

/** Fecha ISO (YYYY-MM-DD) → etiqueta legible en español. */
export function fechaLegible(iso) {
  const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return '';
  return `${d} de ${meses[m - 1]} de ${y}`;
}
